// Note: Ignore eslint rule for string concatenation within regular expressions
/* eslint-disable prefer-template */

/**
 * Takes the input search string (e.g., 'ethylene usa') and the current
 * marker string and returns if the keywords are ALL contained
 */
export function isMatch(keywords: string, description: string): boolean {
  // Version 1 (basic string inclusion check, decent performance, bad UX)
  // return description.toLowerCase().includes(keywords.toLowerCase());

  // Version 2 (advanced regex for high performance, best UX)
  const keywordsEscaped = keywords.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp('(?=.*?\\b' + keywordsEscaped.split(' ').join(')(?=.*?\\b') + ').*', 'i');

  return regex.test(description);
}
